const Momentum = `
import time
import numpy as np

token = "Your_API_Key"  # Refer to Step 2 in the User Guide above to retrieve your API Key
NSC = NUSwapConnector(token)

symbol = "BTCUSD"  # cyptocurrency code of your choice
pos_held = False

window = 20  # Window size for calculating the momentum

while True:
    print("")
    print("Checking Price")
    
    market_data = NSC.getMarketHistory(symbol)
    
    close_list = []
    for data in market_data:
        close_list.append(data['close'])
    
    close_list = np.array(close_list, dtype=np.float64)
    
    # Calculate returns over the last 'window' periods
    returns = np.diff(close_list[-window:]) / close_list[-window:-1]
    
    # Calculate momentum as the mean of returns
    momentum = np.mean(returns)
    
    last_price = close_list[-1]
    
    print("Momentum: " + str(momentum))
    print("Last Price: " + str(last_price))
    
    # Define a threshold for momentum to trigger a trade
    momentum_threshold = 0.05  # Example threshold
    
    if momentum > momentum_threshold and not pos_held:  # Buy signal
        print("Buy signal detected! Placing order...")
        NSC.placeOrder(symbol, 'Market', 'Buy', 1) 
        pos_held = True
    
    elif momentum < -momentum_threshold and pos_held:  # Sell signal
        print("Sell signal detected! Placing order...")
        NSC.placeOrder(symbol, 'Market', 'Sell', 1) 
        pos_held = False
    
    time.sleep(60)  # Sleep for 60 seconds before checking again`

export default Momentum;